import React from "react";
import { RCCGrid } from "react-common-components";
import SortableHandle from "src/components/Sortable/Handle";
import { IActionCancelRef } from "src/pages/Actions/Panel/components/modalCancel";
import { IActionPostponementRef } from "src/pages/Actions/Panel/components/modalPostponement";
import { ActionSituationFilter, IRefActionsPanelModalAddChangeDelete, IRefActionsProgressModal } from "src/pages/Actions/Panel/interface";
import OptionsOfActions from "src/pages/Actions/Panel/components/OptionsOfActions";
import Handle from "../DroppableContainer/components/Handle";
import { RowKanban } from "../../kanbanModes/MultipleKanbans/interface";
import { ContainerWithMargin, Header } from "./styles";

export interface Props{
  value: RowKanban;
	modalsRef?: React.RefObject<IRefActionsPanelModalAddChangeDelete>;
  modalProgressRef?: React.RefObject<IRefActionsProgressModal>;
  modalPostponementRef?: React.RefObject<IActionPostponementRef>;
  modalCancelRef?: React.RefObject<IActionCancelRef>;
	onCallbackUpdateFunction?: Function;
	handleProps?: React.HTMLAttributes<any>;
	disabled: boolean;
}

const SimplifiedCard : React.FC<Props> = ({
	value,
	modalCancelRef,
	modalPostponementRef, 
	modalProgressRef,
	modalsRef,	
	onCallbackUpdateFunction,
	disabled = false
}) => {

	let color: "grey" | "green" | "blue" | "red" | "yellow" | "purple" = "grey";
	switch(value.situation){
	case ActionSituationFilter.FINISHED:
		color = "green";
		break;
	case ActionSituationFilter.DELAYED:
		color = "red";
		break;
	case ActionSituationFilter.NOT_STARTED:
		color = "purple";
		break;
	case ActionSituationFilter.IN_PROGRESS:
		color = "blue";
		break;
	case ActionSituationFilter.NEXT_TO_EXPIRE:
		color = "yellow";
		break;
	default: 
		break;
	}

	return(
		<>
			{value.traceability !== undefined ? (
				<ContainerWithMargin color={color}>
					<Header>
						<span 	style={{ maxWidth: "calc(100% - 60px)" }} className="title" title={`${value.inb001Codigo} - ${value.inb001Titulo}`}>{`${value.inb001Codigo} - ${value.inb001Titulo}`}</span>		
						<RCCGrid
							container
							item
							justifyContent="center"
							alignContent="center"
							alignItems="center"
							style={{ width: "60px" }}
						>
							<OptionsOfActions 
								row={value}
								positionOptions="leftEnd"
								actionButtonDelete={() => {
									modalsRef?.current?.actionButtonDelete(value);
								}}
								openModalActionCancel={() => {
									modalCancelRef?.current?.openModalActionCancel(value.inb001Id, `${value.inb001Codigo} - ${value.inb001Titulo}`, () =>  {
										if(onCallbackUpdateFunction)
											onCallbackUpdateFunction(value.inb001Id);
									});
								}}
								openModalActionPostponement={() => {
									modalPostponementRef?.current?.openModalActionPostponement(value.inb001Id, `${value.inb001Codigo} - ${value.inb001Titulo}`, value.inb001Dtfim , () =>  {
										if(onCallbackUpdateFunction)
											onCallbackUpdateFunction(value.inb001Id);
									});
								}}
								openModalAddOrChange={(isDisabled) => {
									modalsRef?.current?.openModalAddOrChange(value.inb001Id, () =>  {
										if(onCallbackUpdateFunction)
											onCallbackUpdateFunction(value.inb001Id);
									}, undefined, undefined, undefined, undefined, undefined, isDisabled);
								}}
								openModalAddSubaction={() => {
									modalsRef?.current?.openModalAddOrChange(undefined, () =>  {
										if(onCallbackUpdateFunction)
											onCallbackUpdateFunction(value.inb001Id);
									});
								}}
								openModalChangeProgress={(isReopen: boolean) => {
									modalProgressRef?.current?.openModalChangeProgress(value.inb001Id, `${value.inb001Codigo} - ${value.inb001Titulo}`, value.inb001PercConclusao , () =>  {
										if(onCallbackUpdateFunction)
											onCallbackUpdateFunction(value.inb001Id);
									}, isReopen);
								}}
							/>
							{!disabled && (
								<SortableHandle>
									<Handle />
								</SortableHandle>
							)}
			 			</RCCGrid>
					</Header>
				</ContainerWithMargin>
			) : null}
		</>
	);
	
};

export default SimplifiedCard;
